/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Tournament_No_Round_To_FinishInputs */



/**
* | output |
* | --- |
* | "No rounds to finish" |
*
* @param {Err_Tournament_No_Round_To_FinishInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_tournament_no_round_to_finish = /** @type {((inputs?: Err_Tournament_No_Round_To_FinishInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Tournament_No_Round_To_FinishInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucune ronde à terminer")
	if (locale === "es") return /** @type {LocalizedString} */ ("No hay ninguna ronda que finalizar")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Nenhuma rodada para encerrar")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun round da terminare")
	return /** @type {LocalizedString} */ ("No rounds to finish")
});